import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const AddNewBreak = ({
  showAddBreakModal,
  handleAddBreakModalDisplay,
  handleAddNewBreak,
}) => (
  <>
    <Button
      size="sm"
      variant="primary"
      onClick={() => {
        handleAddBreakModalDisplay(true);
      }}
    >
      Add New Break
    </Button>

    <Modal
      show={showAddBreakModal}
      onHide={() => {
        handleAddBreakModalDisplay(false);
      }}
      centered
    >
      <Modal.Header>
        <Modal.Title className="m-0">Add New Break</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            handleAddBreakModalDisplay(false);
          }}
        />
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{
          breakName: '',
          shortCode: '',
          billable: false,
        }}
        validationSchema={Yup.object({
          breakName: Yup.string().required('Enter break name'),
          shortCode: Yup.string().max(
            5,
            'Short code must be 5 characters or less'
          ),
        })}
        onSubmit={(values) => {
          handleAddNewBreak(values);
        }}
      >
        {(formikprops) => (
          <Form onSubmit={formikprops.handleSubmit}>
            <Modal.Body>
              <section>
                <Form.Group controlId="breakName">
                  <Form.Label>
                    Break name <span className="text-danger">*</span>
                  </Form.Label>
                  <Field
                    className="form-control"
                    type="text"
                    placeholder="Enter break name"
                    name="breakName"
                  />
                  <ErrorMessage
                    name="breakName"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Form.Group>
                <Form.Group controlId="shortCode">
                  <Form.Label>
                    Short Code <span className="text-muted">(max 5 char)</span>
                  </Form.Label>
                  <Field
                    className="form-control"
                    type="text"
                    placeholder="Enter short code"
                    name="shortCode"
                  />
                  <ErrorMessage
                    name="shortCode"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Form.Group>
                {/* 
                <Form.Group>
                  <label htmlFor="billable">
                    <input
                      className="form-check-input form-check-border mt-1 me-2"
                      type="checkbox"
                      value=""
                      aria-label="Checkbox for following text input"
                      name="billable"
                      onChange={(e) => {
                        formikprops.setFieldValue(
                          'billable',
                          !formikprops.values.billable
                        );
                      }}
                      checked={formikprops.values.billable}
                    />
                    Productive
                  </label>
                </Form.Group>
                */}
              </section>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              <Button
                variant="link"
                onClick={() => {
                  handleAddBreakModalDisplay(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Add Break
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  </>
);

AddNewBreak.propTypes = {
  showAddBreakModal: PropTypes.bool,
  handleAddBreakModalDisplay: PropTypes.func,
  handleAddNewBreak: PropTypes.func,
};

export default AddNewBreak;
